import { TMCClientParameters } from '@sdbn/tmc-common';
import { UmbrueckungDetails } from './../model/umbrueckung-details';
import { ResponseStatus } from '@sdbn/common';
import { TargetTransport } from './../model/target-transport';
import { ColumnDefinition } from '@sdbn/common';
import { Row } from '@sdbn/common';
import { SelectionType } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { TmcTableModel } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { TransportScope } from "../../../common/model/transport.model";
import { ServiceResponse } from '@sdbn/common';
import { BeginUmbrueckung } from '../model/begin-umbrueckung';
import { AppClientConfigurationService } from '@sdbn/common';

@Component({
  selector: 'app-begin-umbrueckung-dialog',
  templateUrl: './begin-umbrueckung-dialog.component.html',
  styleUrls: ['./begin-umbrueckung-dialog.component.scss']
})
export class BeginUmbrueckungDialogComponent implements OnInit {

  details: UmbrueckungDetails;

  /** page 0 = transport selection, page 1 == add missing source transport details */
  currentPage = 0;

  responseMessages: ResponseMessage[];
  isLoading = false;
  tableModel: TmcTableModel = new TmcTableModel();

  defaultColumnDefinitions: ColumnDefinition[];
  // columns not visible but mandatory for data holding and search function
  mandatoryMetaColumns: ColumnDefinition[] = new Array<ColumnDefinition>();

  selectedTargetTransport = new TargetTransport({});

  constructor(
    public cps: AppClientConfigurationService,
    public dialogRef: MatDialogRef<BeginUmbrueckungDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService
  ) {

    this.details = data.details;


    this.tableModel.selectionType = SelectionType.SINGLE;
    this.tableModel.sortable = true;
    this.tableModel.filterable = true;

    this.defineColumns();

    this.tableModel.setRows(this.convertToTableRows(data.details.targetTransports));
  }

  ngOnInit() {
  }

  private defineColumns() {
    this.initDefaultColumnDefinitions();

    this.tableModel.columnDefinitions.push(...this.defaultColumnDefinitions);

    this.tableModel.columnDefinitions.push(...this.mandatoryMetaColumns);
  }

  private findColumnDefinitionById(columnId: string) {
    for (const definition of this.defaultColumnDefinitions) {
      if (definition.id === columnId) {
        return definition;
      }
    }
    return null;
  }


  private initDefaultColumnDefinitions() {

    const i18nPrefix = 'tmc.begin-umbrueckung-dialog.table.column.';
    this.defaultColumnDefinitions = [
      { id: 'carrier', name: 'carrier', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'carrier', sticky: false },
      { id: 'cargo', name: 'cargo', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'cargo' },
      { id: 'currentStation', name: 'currentStation', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'currentStation' },
      { id: 'transportOptions', name: 'transportOptions', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'transportOptions' },
      {
        id: 'numberPlate', name: 'numberPlate', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'numberPlate'
      },
      {
        id: 'trailerNumberPlate', name: 'trailerNumberPlate', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'trailerNumberPlate'
      },
      { id: 'swapTrailerNumber', name: 'swapTrailerNumber', visible: true, type: ColumnType.STRING, translationKey: i18nPrefix + 'swapTrailerNumber' },
      { id: 'scopeDict', name: 'scope', visible: true, type: ColumnType.DICTIONARY, translationKey: i18nPrefix + 'scope' }
    ];
  }


  private convertToTableRows(transports: TargetTransport[]): Row[] {
    const rows: Row[] = [];
    for (const t of transports) {
      const row: Row = new Row();
      row.id = t.id + '';
      row.values = {
        id: t.id, carrier: t.carrier, cargo: t.cargo, currentStation: t.currentStation,
        transportOptions: t.transportOptions, numberPlate: t.numberPlate, trailerNumberPlate: t.trailerNumberPlate,
        swapTrailerNumber: t.swapTrailerNumber
      };

      row.values.scopeDict = 'tmc.transport-scope.' + t.transportScope;

      if (t.cargo != null && t.cargo.length > 0) {
        row.columnStyles.set('cargo', ['multiple-lines']);
      }

      if (t.transportOptions != null && t.transportOptions.length > 0) {
        row.columnStyles.set('transportOptions', ['multiple-lines']);
      }

      rows.push(row);
    }

    return rows;
  }

  public isCloseDialogDisabled() {
    return false;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public beginUmbrueckung() {

    const request = new BeginUmbrueckung();
    request.sourceTransport = { id: this.details.id };
    request.sourceTransportStationId = { id: this.details.currentStationId };
    request.targetTransport = { id: this.selectedTargetTransport.id };
    request.targetTransportStationId = { id: this.selectedTargetTransport.currentStationId };

    request.swapTrailerNumber = this.details.swapTrailerNumber;
    request.trailerNumberPlate = this.details.trailerNumberPlate;

    this.appServerAPI.execute<ServiceResponse>('/client/control/umbrueckung/begin', request).subscribe(
      response => {
        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
      },
      error => {
        console.log('Unexpexted Error: ' + error);
      }
    );
  }

  public isBeginUmbrueckungDisabled() {
    if (this.isTrailerNumberPlateRequired()
      && (this.details.trailerNumberPlate == null || this.details.trailerNumberPlate.length === 0)) {
      return true;
    }

    if (this.isSwapTrailerNumberRequired()
      && (this.details.swapTrailerNumber == null || this.details.swapTrailerNumber.length === 0)) {
      return true;
    }

  }

  public stepBack() {
    if (this.currentPage >= 1) {
      this.currentPage -= 1;
    }
  }

  public isSelectTargetTransportDisabled(): boolean {
    return this.tableModel.selectedRows.length !== 1;
  }

  public selectTargetTransport() {
    this.currentPage = 1;

    const selection = this.details.targetTransports.filter(t => t.id === +this.tableModel.selectedRows[0].id)[0];

    this.selectedTargetTransport = new TargetTransport({});
    this.selectedTargetTransport.id = selection.id;
    this.selectedTargetTransport.trailerNumberPlate = selection.trailerNumberPlate;
    this.selectedTargetTransport.swapTrailerNumber = selection.swapTrailerNumber;
    this.selectedTargetTransport.currentStationId = selection.currentStationId;
    this.selectedTargetTransport.transportScope = selection.transportScope;
  }

  public isTrailerNumberPlateRequired(): boolean {
    return this.selectedTargetTransport.transportScope === TransportScope.TRAILER;
  }

  public isTrailerNumberVisible(): boolean {
    return this.selectedTargetTransport.transportScope === TransportScope.TRAILER;
  }

  public isSwapTrailerNumberRequired(): boolean {
    if (this.isSwapTrailerEnabled()) {
      return this.selectedTargetTransport.transportScope === TransportScope.SWAP_TRAILER;
    }
    return false;
  }

  public isSwapTrailerEnabled(): boolean {
    return this.cps.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

}

